/*
 * @Author: liuxw@codoon.com
 * @Date: 2020-07-21 16:49:55
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2021-07-12 10:49:39
 * @Content:
 */

import { IActivityInfo } from "../../service/activity/interface";

/**
 * 判断活动是否结束
 */
// 活动时间状态，0: 活动未开始，1: 活动进行中，2: 活动已经结束
export function actTimeState(detail: IActivityInfo): number {
  const now = new Date();
  const effect_end = new Date(detail.effect_end.replace(/-/g, "/"));
  const effect_start = new Date(detail.effect_start.replace(/-/g, "/"));

  if (now.getTime() >= effect_end.getTime()) {
    return 2;
  }
  if (
    now.getTime() < effect_end.getTime() &&
    now.getTime() > effect_start.getTime()
  ) {
    return 1;
  }
  if (now.getTime() < effect_start.getTime()) {
    return 0;
  }
  return 0;
}
